import {
    INVALIDATE_PROMOCIONES,
    REQUEST_PROMOCIONES, RECEIVE_PROMOCIONES, ERROR_PROMOCIONES
} from '../actions/PromocionesActions';
import { combineReducers } from 'redux';
import normalizeDatos from "../normalizers/normalizePromociones";

function productosById(state = {
    isFetching: false,
    didInvalidate: true,
    productos: []
}, action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                productos: action.promociones.entities.productos,
                lastUpdated: action.receivedAt
            });
        default:
            return state
    }
}


function allProductos(state = [], action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return Object.keys(action.promociones ? action.promociones.entities.productos : []);
        default:
            return state
    }
}


const productos = combineReducers({
    byId : productosById,
    allIds : allProductos
});

export default productos;


// WEBPACK FOOTER //
// ./src/reducers/productos.js